import type { Video } from "@/types/video";

export const moviesVideos: Video[] = [
  {
    id: "mv-01",
    title: "孤星坠落",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20drifting%20through%20a%20vast%20glowing%20nebula%2C%20dramatic%20rim%20lighting%2C%20deep%20navy%20and%20orange%20color%20grading%2C%20volumetric%20light%2C%20highly%20detailed%20atmospheric%20sci-fi%20mood%2C%20editorial%20poster%20composition&width=800&height=450&seq=mv-01&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2024,
    rating: 8.7,
    views: 1286000,
    updateDate: "2026-10-12",
    director: "艾伦·沃克",
    actors: ["凯文·布朗", "艾米莉亚·雷诺"],
    description:
      "一艘深空探测飞船在返航途中遭遇未知引力场，唯一的幸存者必须在氧气耗尽前破解星图密码，揭开孤星坠落的真相。宏大视听与硬核科幻设定交织，探讨人类在宇宙孤独中的选择。",
    tags: ["科幻", "冒险", "太空"],
  },
  {
    id: "mv-02",
    title: "暗流涌动",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20noir%20movie%20poster%20of%20a%20rain-soaked%20city%20street%20at%20night%20with%20a%20lone%20silhouette%20under%20a%20street%20lamp%2C%20moody%20teal%20and%20amber%20grading%2C%20wet%20reflections%2C%20gritty%20crime%20thriller%20atmosphere%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=mv-02&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2023,
    rating: 8.2,
    views: 964000,
    updateDate: "2026-10-10",
    director: "陈默",
    actors: ["张屹", "李承宇", "周韵"],
    description:
      "一桩尘封多年的旧案重新浮出水面，退休刑警与年轻记者联手追查，在城市的暗流之下，真相远比想象更危险。节奏紧凑，反转不断。",
    tags: ["犯罪", "悬疑", "剧情"],
  },
  {
    id: "mv-03",
    title: "荒漠追凶",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20western%20thriller%20poster%20of%20a%20dusty%20desert%20highway%20with%20a%20lone%20pickup%20truck%20speeding%20under%20a%20burning%20sunset%2C%20orange%20and%20sepia%20color%20grading%2C%20heat%20haze%2C%20dramatic%20long%20shadows%2C%20highly%20detailed%20cinematic%20composition&width=800&height=450&seq=mv-03&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2022,
    rating: 7.9,
    views: 723000,
    updateDate: "2026-10-08",
    director: "马丁·科尔",
    actors: ["杰克·雷德", "索菲亚·冈"],
    description:
      "横穿沙漠的公路上，一场看似普通的追捕逐渐演变为关于救赎的角力。荒凉风景与紧绷节奏相互映衬，人物命运在漫天黄沙中交汇。",
    tags: ["动作", "公路", "悬疑"],
  },
  {
    id: "mv-04",
    title: "时间尽头",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20poster%20of%20a%20giant%20clockwork%20mechanism%20melting%20into%20a%20starfield%2C%20surreal%20concept%20art%2C%20deep%20indigo%20and%20warm%20gold%20accents%2C%20volumetric%20light%20rays%2C%20highly%20detailed%20atmospheric%20editorial%20composition&width=800&height=450&seq=mv-04&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2025,
    rating: 8.5,
    views: 1103000,
    updateDate: "2026-10-13",
    director: "诺兰·里德",
    actors: ["汤姆·亨利", "艾拉·伍德"],
    description:
      "当时间本身开始倒流，一位钟表匠发现自己是唯一记得正序世界的人。他必须在下一次循环前修正裂痕，否则整个世界将被抹去。",
    tags: ["科幻", "悬疑", "烧脑"],
  },
  {
    id: "mv-05",
    title: "山海故人",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20art%20house%20poster%20of%20misty%20mountains%20and%20a%20lone%20figure%20walking%20a%20winding%20stone%20path%2C%20traditional%20Chinese%20ink%20wash%20aesthetic%20blended%20with%20photographic%20depth%2C%20soft%20green%20and%20grey%20tones%2C%20highly%20detailed%20poetic%20composition&width=800&height=450&seq=mv-05&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2021,
    rating: 8.8,
    views: 812000,
    updateDate: "2026-10-05",
    director: "顾清",
    actors: ["沈墨", "林晚", "周恒"],
    description:
      "跨越三十年的山乡变迁中，两代人的聚散离合被一封迟到的信重新串联。朴素而不失力量的叙事，讲述关于故乡与告别的一切。",
    tags: ["剧情", "文艺", "家庭"],
  },
  {
    id: "mv-06",
    title: "城市之光",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20neon%20lit%20metropolis%20skyline%20at%20dusk%20with%20flying%20birds%20and%20warm%20window%20lights%2C%20orange%20and%20deep%20blue%20contrast%2C%20reflective%20glass%20surfaces%2C%20highly%20detailed%20urban%20editorial%20composition&width=800&height=450&seq=mv-06&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2024,
    rating: 7.6,
    views: 654000,
    updateDate: "2026-10-11",
    director: "苏航",
    actors: ["高野", "许清歌"],
    description:
      "在一座不眠的城市里，五个陌生人的命运因一场停电而交叠。平凡个体的微光汇聚，照亮了城市夜晚最柔软的角落。",
    tags: ["都市", "群像", "温情"],
  },
  {
    id: "mv-07",
    title: "深海回响",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20poster%20of%20a%20deep%20sea%20submersible%20descending%20through%20dark%20blue%20water%20with%20bioluminescent%20creatures%2C%20volumetric%20light%20shafts%2C%20teal%20and%20amber%20accents%2C%20highly%20detailed%20atmospheric%20cinematic%20composition&width=800&height=450&seq=mv-07&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2023,
    rating: 8.0,
    views: 690000,
    updateDate: "2026-10-09",
    director: "汉娜·福特",
    actors: ["乔治·兰", "妮可·奥斯汀"],
    description:
      "深海科考队在马里亚纳海沟捕捉到一段无法解释的低频信号，随着下潜深度增加，他们发现海底深处藏着一个比黑暗更古老的存在。",
    tags: ["惊悚", "科幻", "海洋"],
  },
  {
    id: "mv-08",
    title: "无名之辈",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20ordinary%20working%20class%20people%20standing%20in%20a%20narrow%20alley%20at%20golden%20hour%2C%20warm%20amber%20and%20shadowed%20tones%2C%20gritty%20realism%2C%20highly%20detailed%20emotional%20editorial%20composition&width=800&height=450&seq=mv-08&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2022,
    rating: 8.3,
    views: 778000,
    updateDate: "2026-10-06",
    director: "罗宇",
    actors: ["王大鹏", "秦海", "刘敏"],
    description:
      "几个被生活推到墙角的小人物，因一件阴差阳错的旧物而卷入漩涡。荒诞与温情并存，讲述平凡人也有不肯低头的倔强。",
    tags: ["喜剧", "剧情", "现实主义"],
  },
  {
    id: "mv-09",
    title: "极昼",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20snowy%20arctic%20research%20station%20under%20a%20midnight%20sun%2C%20pale%20golden%20light%20on%20white%20ice%2C%20cold%20crisp%20atmosphere%2C%20lone%20figure%20in%20heavy%20coat%2C%20highly%20detailed%20cinematic%20composition&width=800&height=450&seq=mv-09&orientation=landscape",
    type: "movie",
    region: "其他",
    year: 2024,
    rating: 7.8,
    views: 512000,
    updateDate: "2026-10-07",
    director: "伊万·诺瓦",
    actors: ["安娜·林德", "彼得·索"],
    description:
      "北极极昼期间，一处科考站与外界彻底失联。当永昼不再入夜，站内的每个人都开始怀疑，究竟是谁在操纵这场没有尽头的白天。",
    tags: ["悬疑", "惊悚", "极地"],
  },
  {
    id: "mv-10",
    title: "山雨欲来",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20period%20drama%20poster%20of%20a%20traditional%20Chinese%20courtyard%20under%20threatening%20storm%20clouds%2C%20lanterns%20glowing%20warm%20amber%2C%20deep%20grey%20sky%2C%20rain%20about%20to%20fall%2C%20highly%20detailed%20atmospheric%20editorial%20composition&width=800&height=450&seq=mv-10&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2020,
    rating: 8.6,
    views: 845000,
    updateDate: "2026-10-04",
    director: "郑渊",
    actors: ["何明", "叶知秋"],
    description:
      "乱世将启的前夜，一座古老宅院里的各方势力暗流涌动。每个人都在等待一场山雨，而这场雨将冲刷掉所有的伪装。",
    tags: ["历史", "剧情", "权谋"],
  },
  {
    id: "mv-11",
    title: "归途列车",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20old%20train%20traveling%20through%20golden%20autumn%20countryside%20at%20sunset%2C%20warm%20orange%20light%20streaming%20through%20windows%2C%20nostalgic%20film%20grain%2C%20highly%20detailed%20emotional%20cinematic%20composition&width=800&height=450&seq=mv-11&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2023,
    rating: 8.1,
    views: 604000,
    updateDate: "2026-10-03",
    director: "丁宁",
    actors: ["赵远", "孙淼"],
    description:
      "一趟开往故乡的夜行列车，承载着不同乘客各自的心事。旅程中，一段被时间掩埋的往事重新被拾起，归途也是和解之路。",
    tags: ["剧情", "温情", "公路"],
  },
  {
    id: "mv-12",
    title: "迷雾之城",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20poster%20of%20a%20city%20skyline%20engulfed%20in%20thick%20fog%20with%20only%20tallest%20towers%20visible%2C%20cool%20grey%20and%20amber%20beacons%2C%20eerie%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-12&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2022,
    rating: 7.7,
    views: 566000,
    updateDate: "2026-10-02",
    director: "卢卡斯·梅",
    actors: ["丹尼尔·李", "克莱尔·周"],
    description:
      "一场持续三十天的浓雾笼罩全城，雾中归来的居民记忆出现空白。心理医生与警探联手追寻，却发现真相藏在每个人的脑海里。",
    tags: ["悬疑", "奇幻", "心理"],
  },
  {
    id: "mv-13",
    title: "猎影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20poster%20of%20a%20shadowy%20figure%20leaping%20across%20rooftops%20at%20blue%20hour%2C%20dynamic%20motion%20blur%2C%20orange%20streetlights%20below%2C%20high%20contrast%2C%20gritty%20urban%20thriller%20mood%2C%20highly%20detailed%20cinematic%20composition&width=800&height=450&seq=mv-13&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2025,
    rating: 8.4,
    views: 1023000,
    updateDate: "2026-10-14",
    director: "雷戈",
    actors: ["吴锋", "黎婉"],
    description:
      "顶尖追踪专家接手一桩连环失踪案，却发现猎物与自己有着相同的过去。猎人与猎物的身份在夜色中不断反转，直到最后一枪。",
    tags: ["动作", "犯罪", "悬疑"],
  },
  {
    id: "mv-14",
    title: "长夜将尽",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20dim%20hospital%20corridor%20at%20dawn%20with%20light%20breaking%20through%20blinds%2C%20soft%20golden%20and%20grey%20tones%2C%20solitary%20figure%2C%20highly%20detailed%20emotional%20editorial%20composition&width=800&height=450&seq=mv-14&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2024,
    rating: 8.9,
    views: 917000,
    updateDate: "2026-10-15",
    director: "简川",
    actors: ["温以宁", "程越"],
    description:
      "一位临终关怀医生与一位拒绝治疗的病人，在漫长的夜晚里彼此治愈。关于生命、尊严与告别的温柔之作，被誉为本年度最动人之作。",
    tags: ["剧情", "治愈", "人生"],
  },
  {
    id: "mv-15",
    title: "破风而行",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sports%20poster%20of%20cyclists%20racing%20through%20a%20mountain%20pass%20at%20sunrise%2C%20dynamic%20speed%20lines%2C%20orange%20and%20blue%20dawn%20sky%2C%20sweat%20and%20determination%2C%20highly%20detailed%20energetic%20cinematic%20composition&width=800&height=450&seq=mv-15&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2023,
    rating: 7.5,
    views: 431000,
    updateDate: "2026-09-28",
    director: "马力",
    actors: ["陈旭", "白鸽"],
    description:
      "一支濒临解散的业余自行车队，为了最后一场比赛重新集结。逆风、伤病与质疑面前，他们用速度证明热爱并非年少轻狂。",
    tags: ["运动", "励志", "青春"],
  },
  {
    id: "mv-16",
    title: "无声告白",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20young%20woman%20signing%20with%20hands%20in%20soft%20window%20light%2C%20warm%20intimate%20tones%2C%20shallow%20depth%20of%20field%2C%20tender%20emotional%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-16&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2021,
    rating: 8.2,
    views: 488000,
    updateDate: "2026-09-26",
    director: "柳青",
    actors: ["安然", "许知远"],
    description:
      "一位听障舞者在无声的世界里追逐舞台梦想，与一位失意的音乐制作人相遇后，两人用不同的语言听见了彼此的心跳。",
    tags: ["爱情", "剧情", "治愈"],
  },
  {
    id: "mv-17",
    title: "黄金年代",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20nostalgic%20poster%20of%20a%20vintage%201980s%20theatre%20marquee%20glowing%20gold%20at%20night%2C%20retro%20city%20street%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20film%20grain%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-17&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2020,
    rating: 8.5,
    views: 639000,
    updateDate: "2026-09-24",
    director: "关河",
    actors: ["梁川", "苏玉"],
    description:
      "上世纪八十年代，一群年轻人在城市剧院的灯光下追逐梦想。时代洪流滚滚向前，他们的友情、爱情与理想都刻在了那段黄金年代。",
    tags: ["年代", "剧情", "群像"],
  },
  {
    id: "mv-18",
    title: "追光者",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20inspiring%20poster%20of%20a%20photographer%20silhouette%20chasing%20golden%20sunlight%20through%20a%20field%20of%20tall%20grass%2C%20lens%20flare%2C%20warm%20orange%20and%20green%20tones%2C%20hopeful%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-18&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2024,
    rating: 7.9,
    views: 502000,
    updateDate: "2026-09-22",
    director: "何夕",
    actors: ["林一", "莫桐"],
    description:
      "一名纪实摄影师深入偏远山区，用镜头记录即将消失的手艺与人生。在追逐光影的路上，他也重新找到了自己。",
    tags: ["剧情", "励志", "人文"],
  },
  {
    id: "mv-19",
    title: "逆流而上",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20kayak%20battling%20white%20water%20rapids%20in%20a%20deep%20canyon%2C%20spray%20and%20motion%2C%20cool%20blue%20water%20with%20warm%20rock%20tones%2C%20dramatic%20energy%2C%20highly%20detailed%20cinematic%20composition&width=800&height=450&seq=mv-19&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2022,
    rating: 7.4,
    views: 398000,
    updateDate: "2026-09-20",
    director: "斯宾塞·高",
    actors: ["瑞恩·柯", "玛雅·凯"],
    description:
      "一次意外让退役皮划艇运动员失去一切，为了救回被困峡谷的旧友，他必须再次逆流而上，直面曾经击败自己的那段激流。",
    tags: ["冒险", "剧情", "运动"],
  },
  {
    id: "mv-20",
    title: "雪落长街",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20winter%20poster%20of%20a%20quiet%20snow-covered%20old%20city%20street%20with%20warm%20yellow%20shop%20windows%2C%20falling%20snowflakes%2C%20soft%20romantic%20tones%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-20&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2023,
    rating: 8.0,
    views: 561000,
    updateDate: "2026-09-18",
    director: "申雪",
    actors: ["韩冰", "柯以柔"],
    description:
      "初雪降临的老街，一家即将停业的钟表店迎回多年未归的女儿。雪落无声，父女之间横亘多年的沉默终于被时间敲开一道缝。",
    tags: ["爱情", "文艺", "家庭"],
  },
  {
    id: "mv-21",
    title: "铁血荣光",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20war%20film%20poster%20of%20soldiers%20advancing%20through%20smoke%20at%20dawn%2C%20dramatic%20backlight%2C%20desaturated%20grey%20with%20orange%20embers%2C%20gritty%20realistic%20battlefield%2C%20highly%20detailed%20cinematic%20composition&width=800&height=450&seq=mv-21&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2021,
    rating: 8.7,
    views: 826000,
    updateDate: "2026-09-16",
    director: "岳峰",
    actors: ["段承", "陆沉", "霍骁"],
    description:
      "一场决定战局的关键战役中，一支小小的先遣队扛下了数倍于己的敌人。没有英雄的光环，只有血肉之躯铸就的防线与不灭的信念。",
    tags: ["战争", "历史", "热血"],
  },
  {
    id: "mv-22",
    title: "幻影迷踪",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20illusionist%20poster%20of%20a%20magician%20silhouette%20surrounded%20by%20mirrors%20and%20floating%20playing%20cards%2C%20mysterious%20purple-free%20deep%20blue%20and%20gold%20lighting%2C%20smoke%2C%20highly%20detailed%20theatrical%20cinematic%20composition&width=800&height=450&seq=mv-22&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2024,
    rating: 7.8,
    views: 473000,
    updateDate: "2026-09-14",
    director: "菲利普·让",
    actors: ["奥利弗·唐", "伊莎·贝"],
    description:
      "举世闻名的魔术师在最后一场演出中当众离奇消失，留下的只有一个打不开的道具箱。他的徒弟为寻找真相，踏入了由谎言编织的迷宫。",
    tags: ["悬疑", "犯罪", "魔术"],
  },
  {
    id: "mv-23",
    title: "星尘之约",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20sci-fi%20poster%20of%20two%20silhouettes%20holding%20hands%20under%20a%20shooting%20star%20sky%2C%20vast%20milky%20way%2C%20soft%20indigo%20and%20warm%20starlight%2C%20dreamy%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-23&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2025,
    rating: 8.3,
    views: 892000,
    updateDate: "2026-09-12",
    director: "沈星河",
    actors: ["江野", "顾星野"],
    description:
      "一对恋人相隔光年，只能通过每隔数年的信号彼此确认存在。当科技终于让他们靠近，时间却已成为最遥远的距离。浪漫与科幻交织的深情之作。",
    tags: ["爱情", "科幻", "催泪"],
  },
  {
    id: "mv-24",
    title: "春江花月",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20period%20poster%20of%20a%20moonlit%20river%20with%20blossoming%20plum%20branches%20and%20a%20small%20painted%20boat%2C%20soft%20pink%20and%20deep%20blue%20tones%2C%20traditional%20Chinese%20poetic%20aesthetic%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=mv-24&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2022,
    rating: 8.4,
    views: 578000,
    updateDate: "2026-09-10",
    director: "折枝",
    actors: ["纳兰", "沈书"],
    description:
      "江南水乡，一位才女与一位漂泊画师因一幅《春江花月》结缘。诗画唱和间情愫暗生，却在时代的动荡中迎来各自的人生抉择。",
    tags: ["古装", "爱情", "文艺"],
  },
  {
    id: "mv-25",
    title: "最后的证人",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20legal%20thriller%20poster%20of%20a%20lone%20figure%20in%20a%20dim%20courtroom%20with%20dramatic%20overhead%20light%2C%20cold%20grey%20and%20amber%20tones%2C%20tense%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-25&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2023,
    rating: 8.1,
    views: 548000,
    updateDate: "2026-09-08",
    director: "格蕾丝·霍",
    actors: ["艾德·华", "罗莎·琳"],
    description:
      "一桩轰动全城的案件即将终审，唯一的目击证人在开庭前一天意外失忆。年轻律师必须在有限的时间里拼凑真相，却发现证词背后另有隐情。",
    tags: ["悬疑", "律政", "剧情"],
  },
  {
    id: "mv-26",
    title: "风暴中心",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20disaster%20poster%20of%20a%20massive%20spiral%20storm%20over%20the%20ocean%20seen%20from%20above%2C%20dark%20swirling%20clouds%2C%20dramatic%20scale%2C%20cool%20blue%20and%20grey%20tones%20with%20warm%20sun%20edge%2C%20highly%20detailed%20cinematic%20composition&width=800&height=450&seq=mv-26&orientation=landscape",
    type: "movie",
    region: "欧美",
    year: 2024,
    rating: 7.6,
    views: 601000,
    updateDate: "2026-09-06",
    director: "亚当·崔",
    actors: ["卢卡斯·本", "艾美·德"],
    description:
      "超强飓风直扑沿海城市，气象学家与救援队长在风暴来临前争分夺秒。当自然的力量不可阻挡，人类唯一能做的选择，是彼此守望。",
    tags: ["灾难", "动作", "惊险"],
  },
  {
    id: "mv-27",
    title: "一念之间",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20philosophical%20poster%20of%20a%20single%20split%20road%20in%20a%20misty%20forest%20at%20twilight%2C%20two%20diverging%20paths%20of%20light%2C%20moody%20teal%20and%20amber%20tones%2C%20contemplative%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-27&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2022,
    rating: 8.0,
    views: 447000,
    updateDate: "2026-09-04",
    director: "郁白",
    actors: ["方棠", "江离"],
    description:
      "一次看似微不足道的选择，让主人公的人生分裂成两个平行的版本。两条交错的时间线里，他不断追问：若当初回头，结局会不会不同。",
    tags: ["剧情", "奇幻", "烧脑"],
  },
  {
    id: "mv-28",
    title: "深渊凝视",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20psychological%20thriller%20poster%20of%20a%20face%20partly%20submerged%20in%20dark%20water%20reflection%2C%20eerie%20symmetry%2C%20cold%20blue%20and%20amber%20accents%2C%20tense%20mysterious%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-28&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2025,
    rating: 8.2,
    views: 733000,
    updateDate: "2026-09-02",
    director: "商隐",
    actors: ["顾言", "沈砚"],
    description:
      "犯罪心理学教授受邀协助调查一系列无法解释的自首案件，每位嫌疑人都声称自己看见了深渊。当他越接近真相，镜子里的自己也越陌生。",
    tags: ["悬疑", "心理", "犯罪"],
  },
  {
    id: "mv-29",
    title: "南方以南",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20travel%20drama%20poster%20of%20a%20winding%20road%20through%20lush%20tropical%20hills%20toward%20the%20sea%2C%20golden%20afternoon%20light%2C%20warm%20green%20and%20amber%20tones%2C%20wanderlust%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-29&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2023,
    rating: 7.7,
    views: 412000,
    updateDate: "2026-08-30",
    director: "海川",
    actors: ["夏楠", "沐野"],
    description:
      "厌倦了都市生活的年轻人踏上南下的旅程，在海岸小镇遇到形形色色的过客。关于逃离与归来、成长与放下的温暖公路故事。",
    tags: ["剧情", "公路", "治愈"],
  },
  {
    id: "mv-30",
    title: "白昼流星",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20meteor%20streaking%20across%20a%20bright%20daytime%20sky%20above%20a%20quiet%20plain%2C%20surreal%20glowing%20trail%2C%20soft%20golden%20and%20pale%20blue%20tones%2C%20poetic%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=mv-30&orientation=landscape",
    type: "movie",
    region: "华语",
    year: 2024,
    rating: 8.6,
    views: 856000,
    updateDate: "2026-08-28",
    director: "陈岭",
    actors: ["牧野", "白露", "杨帆"],
    description:
      "贫困山村里的两个少年，因一次偶然的天文观测而萌生对星空与远方的向往。他们用最朴素的方式追逐梦想，在贫瘠土地上点亮属于自己的流星。",
    tags: ["剧情", "成长", "励志"],
  },
];